const kross = {
  FORMS: [
    {
      type: 'kross-form-wrong-product',
      name: 'KrossWrongProductForm',
      message: {
        open: 'Formulario producto erróneo',
        send: 'Envío Formulario De Producto erróneo'
      }
    },
    {
      type: 'kross-form-delivery-delay',
      name: 'KrossDeliveryDelayForm',
      message: {
        open: 'Formulario producto demora de entrega',
        send: 'Envío Formulario De Demora entrega'
      }
    },
    {
      type: 'kross-form-damaged-product',
      name: 'KrossDamagedProductForm',
      message: {
        open: 'Formulario producto dañado',
        send: 'Envío Formulario De Producto dañado'
      }
    }
  ],
  CSS: {
    id: '61dd7a5a120ec82130f60732',
    name: 'kross',
    avatar: {
      name: 'BETZY',
      header: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/HoHsFS0PGDPT1641912718200.png',
      new: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/N3ZcOuBNjtJu1643222049727.png',
      open: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/ALvy1rhSgZx41641912831499.png',
      close: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/HoHsFS0PGDPT1641912718200.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#73ae45',
        borderColor: '#73ae45'
      }
    }
  }
}

export default kross
